import { useState, useEffect } from "react";
import { X } from "lucide-react";
import axios from "axios";

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

const WelcomePopup = () => {
  const [show, setShow] = useState(false);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    checkAndShowWelcome();
  }, []);

  const checkAndShowWelcome = async () => {
    // Check if user has already seen the welcome message
    const hasSeenWelcome = localStorage.getItem("hasSeenWelcome");
    
    if (hasSeenWelcome === "true") {
      return; // Don't show if already seen
    }

    try {
      // Fetch welcome message settings
      const response = await axios.get(`${API}/welcome-message`);
      
      if (response.data.enabled) {
        setSettings(response.data);
        setShow(true);
      }
    } catch (error) {
      console.error("Error fetching welcome message:", error);
    }
  };

  const handleClose = () => {
    setShow(false);
    // Mark as seen
    localStorage.setItem("hasSeenWelcome", "true");
  };

  if (!show || !settings) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 animate-fadeIn">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 sm:p-8 relative animate-slideUp">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Close"
        >
          <X className="w-5 h-5 text-gray-500" />
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2L4 7v10l8 5 8-5V7l-8-5zm0 2.18L17.82 7 12 9.82 6.18 7 12 4.18zM6 8.82l5 2.5V18.82l-5-2.5V8.82zm12 0v7.5l-5 2.5v-7.5l5-2.5z"/>
            </svg>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-4">
          {settings.title}
        </h2>

        {/* Message */}
        <p className="text-gray-700 text-center leading-relaxed whitespace-pre-wrap mb-6">
          {settings.message}
        </p>

        {/* Button */}
        <button
          onClick={handleClose}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
        >
          Got it!
        </button>
      </div>
    </div>
  );
};

export default WelcomePopup;
